import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { TaxonomyProvider } from "@/context/TaxonomyContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import SelectRole from "@/pages/SelectRole";
import DashboardRedirect from "@/pages/DashboardRedirect";
import Jobs from "@/pages/Jobs";
import JobDetails from "@/pages/JobDetails";
import CandidatesLanding from "@/pages/CandidatesLanding";
import EmployersLanding from "@/pages/EmployersLanding";
import CandidateDashboard from "@/pages/candidate/CandidateDashboard";
import CandidateProfile from "@/pages/candidate/CandidateProfile";
import Applications from "@/pages/candidate/Applications";
import SavedJobs from "@/pages/candidate/SavedJobs";
import EmployerDashboard from "@/pages/employer/EmployerDashboard";
import PostJob from "@/pages/employer/PostJob";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCandidateSearch from "@/pages/admin/AdminCandidateSearch";
import AdminRequirements from "@/pages/admin/AdminRequirements";
import AdminEmployers from "@/pages/admin/AdminEmployers";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/select-role" element={<SelectRole />} />
      <Route path="/dashboard" element={<DashboardRedirect />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/jobs/:id" element={<JobDetails />} />
      <Route path="/candidates" element={<CandidatesLanding />} />
      <Route path="/employers" element={<EmployersLanding />} />

      <Route path="/candidate/dashboard" element={<ProtectedRoute roles={["candidate"]}><CandidateDashboard /></ProtectedRoute>} />
      <Route path="/candidate/profile" element={<ProtectedRoute roles={["candidate"]}><CandidateProfile /></ProtectedRoute>} />
      <Route path="/candidate/applications" element={<ProtectedRoute roles={["candidate"]}><Applications /></ProtectedRoute>} />
      <Route path="/candidate/saved-jobs" element={<ProtectedRoute roles={["candidate"]}><SavedJobs /></ProtectedRoute>} />

      <Route path="/employer/dashboard" element={<ProtectedRoute roles={["employer", "recruiter"]}><EmployerDashboard /></ProtectedRoute>} />
      <Route path="/employer/post-job" element={<ProtectedRoute roles={["employer", "recruiter"]}><PostJob /></ProtectedRoute>} />

      <Route path="/admin/dashboard" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/candidates" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminCandidateSearch /></ProtectedRoute>} />
      <Route path="/admin/requirements" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminRequirements /></ProtectedRoute>} />
      <Route path="/admin/employers" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminEmployers /></ProtectedRoute>} />
      <Route path="/admin/jobs" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminJobs /></ProtectedRoute>} />
      <Route path="/admin/analytics" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminAnalytics /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminSettings /></ProtectedRoute>} />

      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TaxonomyProvider>
          <Toaster position="top-right" richColors />
          <AppRouter />
        </TaxonomyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
